@if (items.length > 0) {
  <mat-expansion-panel>
    <mat-expansion-panel-header (click)="$event.stopPropagation()">
      <mat-panel-title><b>{{ title }}</b></mat-panel-title>
    </mat-expansion-panel-header>
    <mat-nav-list>
      @for (f of items; track f.name) {
        <div
          mat-menu-item
          (click)="onSelect(f)"
          [class.active]="
            selectedBenchmark && f.name === selectedBenchmark.name
          "
          [matTooltip]="f.name_full"
          matTooltipPosition="right"
        >
          {{ f.name_short }}
        </div>
      }
    </mat-nav-list>
  </mat-expansion-panel>
}
